import React, { useEffect, useState } from "react";
import { formatAmountWithSATS } from "../../../utils/Utils";
import { LayoutWithTopBar } from "../../../components/LayoutWithTopBar";
import { useNavigate } from "react-router-dom";
import { InputSearch } from "../../../components/InputSearch";
import SendTxTemplate from "./components/SendTxTemplate";
import { formatNumberWithCommas } from "../../../utils/Utils";
import { getAmountNumber } from "./SendTxAmount";
import { Button, ButtonSize } from "../../../components/Button";
import { ButtonVariant } from "../../../config/colors";
import { useWallet } from "../../../hooks/useWallet";
import { WalletType } from "../../../models/Transactions";
import { canManageMembers } from "../../../models/Pleb";
import { useAuth } from "../../../hooks/useAuth";

const CreateInvoiceAmount: React.FC = () => {
    const navigate = useNavigate();
    const [maxAmountSpendable, setMaxAmountSpendable] = useState<number | null>(null);
    const [amountString, setAmountString] = useState('');
    const [error, setError] = useState('');
    const {walletType} = useWallet();
    const {pleb} = useAuth();

    useEffect(() => {
        if(walletType === WalletType.INTERNAL) {
            if(pleb && canManageMembers(pleb)) {
                setMaxAmountSpendable(null);
            } else {
                setMaxAmountSpendable(1_000_000);
            }
        } else {
            setMaxAmountSpendable(null);
        }
    }, [walletType, pleb]);

    useEffect(() => {
        const amount = getAmountNumber(amountString);
        if(maxAmountSpendable && amount > maxAmountSpendable) {
            setError('Maximum amount is ' + formatAmountWithSATS(maxAmountSpendable));
        } else {
            setError('');
        }
    }, [amountString]);

    const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Get raw input value
        const rawValue = e.target.value;
        // Remove any existing commas
        const cleanValue = rawValue.replace(/,/g, '');
        // Format with commas
        const formattedValue = formatNumberWithCommas(cleanValue);

        const valueNumber = getAmountNumber(formattedValue);

        const maxDigits = maxAmountSpendable ? maxAmountSpendable.toString().length : 9;
                
        if (valueNumber.toString().length <= maxDigits)     
        {
            setAmountString(formattedValue);
        }
    };

    const handleButtonClick = () => {
        navigate('/home/wallet/receive/create-invoice/recap', {
            state: {
                amount: getAmountNumber(amountString)
            }
        });
    }
    
    return (
        <LayoutWithTopBar
            breadcrumbs={[
                { title: 'Wallet', onClick: () => navigate('/home/wallet') },
                { title: 'Receive', onClick: () => navigate('/home/wallet/receive') },
                { title: 'Create invoice' }
            ]}
            onClickPrevArrow={() => navigate('/home/wallet/receive')}
        >
            <SendTxTemplate
                onButtonClick={handleButtonClick}
                buttonDisabled={amountString === '' || error !== ''}
                error={error}
            >
                <InputSearch
                    placeholder="Amount"
                    value={amountString}
                    onChange={handleAmountChange}
                    onClear={() => setAmountString('')}
                    inputMode="numeric"
                />

                {
                    maxAmountSpendable && (
                        <div className="flex flex-row justify-center mt-4">
                            <Button
                                size={ButtonSize.small}
                                onClick={() => setAmountString(formatNumberWithCommas(Math.floor(maxAmountSpendable).toString() ?? ''))}
                                variant={ButtonVariant.unselected}
                                type="button"
                            >
                                Max {formatAmountWithSATS(Math.floor(maxAmountSpendable) ?? 0)}
                            </Button>
                        </div>
                    )
                }
            </SendTxTemplate>
        </LayoutWithTopBar>
    );
}

export default CreateInvoiceAmount;